<template>
    <div>
        <h3>Daftar Pelatihan</h3>
        <v-row>
            <v-col md="3" sm="4" xs="6" v-for="(item) in table.items" :key="item.id">
                <v-card class="mt-2">
                    <v-img height="150" :src="item.gambar_url"></v-img>
                    <v-card-text>
                        <h3 class="my-2" style="text-transform: capitalize;">{{ item.nama }}</h3>
                        <p v-html="item.deskripsi"></p>
                    </v-card-text>
                    <v-card-actions>
                        <router-link :to="{ name: 'PesertaPelatihanDaftar', params: { id: item.id } }">
                            <v-btn title="Lihat" x-small color="primary">
                                Detail
                            </v-btn>
                        </router-link>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <div class="text-center my-4" v-if="table.total > 0">
            <v-btn color="primary"
                   @click="loadMore"
                   :loading="table.loading"
                   :disabled="table.loading || table.items.length >= table.total">
                Muat 12 lagi
            </v-btn>
        </div>
    </div>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiDelete, mdiPencil, mdiEye } from '@mdi/js'

export default {
    data() {
        return {
            icons: { mdiDelete, mdiPencil, mdiEye },
            pageSize: 12,
            table: {
                loading: false,
                items: [],
                total: 0,
                offset: 0,
            },
        }
    },
    computed: {
        user() { return this.$store.getters.user },
    },
    created() {
        this.resetAndLoad()
    },
    methods: {
        resetAndLoad() {
            this.table.items = []
            this.table.offset = 0
            this.table.total = 0
            this.fetchPage()
        },
        fetchPage() {
            if (this.table.loading) return
            this.table.loading = true
            const url = `api/Pelatihan/getPelatihanPeserta?limit=${this.pageSize}&offset=${this.table.offset}`
            axiosGetAuth(url)
                .then(response => {
                    const datas = response.data || []
                    // server sudah mengurutkan terbaru di atas; jika belum, uncomment sorting:
                    // datas.sort((a,b) => new Date(b.created_at || b.tanggal || 0) - new Date(a.created_at || a.tanggal || 0))
                    // gabungkan data baru
                    this.table.items = this.table.items.concat(datas)
                    // simpan total jika dikembalikan oleh API
                    if (typeof response.total !== 'undefined') {
                        this.table.total = response.total
                    } else {
                        this.table.total = this.table.items.length
                    }
                    // update offset untuk next fetch
                    this.table.offset = this.table.items.length
                    this.table.loading = false
                })
                .catch(error => {
                    this.table.loading = false
                    alert(error)
                })
        },
        loadMore() {
            if (this.table.items.length >= this.table.total) return
            this.fetchPage()
        },
        addPendaftaran(item) {
            const fmData = new FormData()
            fmData.append('id_pelatihan', item.id)
            axiosPostAuth('api/Pelatihan/addPendaftaran', fmData)
                .then(response => {
                    alert(response.message)
                })
                .catch(error => {
                    alert(error)
                })
        },
    },
}
</script>